export default function Footer(props) {
    return(
        <div className="footer_container card">
            <span>Copyright © 2022 - Todos los derechos revervados</span>
            <span className="footer_add">Sitio creado en React.js por Sebastian Cardona</span>
        </div>
    )
}